class ImageTextSlider extends HTMLElement {
    constructor() {
        super();
        this.splide = null;
        this.sectionId = this.querySelector('.splide-image-text-mobile')?.dataset.sectionId;
    }

    connectedCallback() {
        if (window.innerWidth < 768) {
            this.initializeSplide();
        }

        window.addEventListener('resize', this.handleResize.bind(this));
    }

    handleResize() {
        if (window.innerWidth < 768 && !this.splide) {
            this.initializeSplide();
        } else if (window.innerWidth >= 768 && this.splide) {
            this.splide.destroy();
            this.splide = null;
        }
    }

    initializeSplide() {
        const splideElement = this.querySelector('.splide-image-text-mobile');
        if (!splideElement || this.splide) return;

        this.loadSplideAssets().then(() => {
            this.createSplideInstance(splideElement);
        });
    }

    loadSplideAssets() {
        return new Promise((resolve) => {
            if (window.Splide) {
                resolve();
                return;
            }

            if (!document.querySelector('link[href*="splide"]')) {
                const cssLink = document.createElement('link');
                cssLink.rel = 'stylesheet';
                cssLink.href = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css';
                document.head.appendChild(cssLink);
            }

            const script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';
            script.onload = resolve;
            document.head.appendChild(script);
        });
    }

    createSplideInstance(splideElement) {
        const splideOptions = {
            type: 'slide',
            perPage: 1,
            perMove: 1,
            gap: '16px',
            arrows: false,
            pagination: false,
            drag: true,
            snap: true,
            keyboard: true,
            focus: 0,
            trimSpace: true,
            rewind: false,
        };

        this.splide = new Splide(splideElement, splideOptions);
        this.setupProgressBar();
        this.splide.mount();
    }

    setupProgressBar() {
    const progressBar = this.querySelector('.slider-progress-bar-mobile');
    if (!progressBar) return;

    const updateProgress = () => {
        const currentIndex = this.splide.index;
        const slidesCount = this.splide.Components.Slides.getLength();
        const perPage = this.splide.options.perPage; // Always 1 in this case
        
        // Calculate progress based on visible content
        const visibleEnd = currentIndex + perPage;
        const progress = (visibleEnd / slidesCount) * 100;
        
        progressBar.style.width = `${Math.min(progress, 100)}%`;
    };

    this.splide.on('moved', updateProgress);
    this.splide.on('mounted', updateProgress);
}

    disconnectedCallback() {
        if (this.splide) {
            this.splide.destroy();
            this.splide = null;
        }
        window.removeEventListener('resize', this.handleResize.bind(this));
    }
}

if (!customElements.get('image-text-slider')) {
    customElements.define('image-text-slider', ImageTextSlider);
}
